export default __webpack_public_path__ + "static/media/downArrow.f63f0809.svg";